import { Box, Grid, Typography } from "@mui/material";
import {
  AccountBalanceWallet,
  ContactSupport,
  DeviceHub,
  Group,
  LocalLibrary,
  LockOpen,
} from "@mui/icons-material";
import { getLayoutText } from "../../../components/layout/getLayoutText";
import { getLayoutView } from "../../../components/layout/getLayoutView";
const Benefits = () => {
  return (
    <Box
      sx={{
        p: "5.5rem 12% 6rem",
        backgroundColor: "white",
      }}
    >
      <Box data-aos="zoom-in-down" data-aos-offset="300" sx={{}}>
        {getLayoutView(
          <>
            A SUPPORTIVE{" "}
            <span style={{ fontFamily: "Lato-Bold" }}> ECOSYSTEM</span>
          </>,
          [
            getLayoutText(
              <>
                YOU GET MORE THAN JUST SOFTWARE. YOU GET THE <span>PEOPLE</span>
                , THOSE WHO WANT YOU TO SUCCEED IN{" "}
                <span> CHANGING THE NARRATIVE</span>
              </>,
              {
                fontSize: "1.25rem",
                fontFamily: "Lato-Regular",
                lineHeight: 2,
                "& span": {
                  fontFamily: "Lato-Bold",
                  color: (theme) => theme.palette.grey[700],
                },
              }
            ),
          ],
          [12],
          {
            p: `0 0 4rem`,
            textAlign: `center`,
            backgroundColor: `transparent`,
            "& .MuiTypography-root:not(.MuiTypography-caption)": {
              color: (theme) => theme.palette.grey[600],
            },
          }
        )}
      </Box>
      <Grid
        data-aos="fade-up"
        data-aos-offset="400"
        container
        spacing={6}
        sx={{ pt: "3rem" }}
      >
        {[
          {
            icon: (p) => <DeviceHub {...p} />,
            name: "Build, Test, & Share",
            text: "We're here at every development phase to help you get your game on the market quickly",
          },
          {
            icon: (p) => <Group {...p} />,
            name: "Group Economics",
            text: "Take advantage of a growing community that promotes engagement and economic participation to help drive your sales",
          },
          {
            icon: (p) => <LockOpen {...p} />,
            name: "Resource Access",
            text: "Get premier content and unique assets to help you get started right away",
          },
          {
            icon: (p) => <AccountBalanceWallet {...p} />,
            name: "Affordable Plans",
            text: "Find the plan that is right for you with our flexible offerings",
          },
          {
            icon: (p) => <LocalLibrary {...p} />,
            name: "Tutorials & Courses",
            text: "Get up to speed with the in-depth resources in our Knowledge Library",
          },
          {
            icon: (p) => <ContactSupport {...p} />,
            name: "Responsive Support",
            text: "Reach out whenever you get stuck, and we'll help you get through any roadblocks you encounter",
          },
        ].map((s, i) => (
          <Grid
            key={`${s.n}:benefit${i}`}
            xs={12}
            sm={6}
            md={4}
            item
            sx={{
              textAlign: `center`,
              "& .MuiTypography-root": { textAlign: `center` },
            }}
          >
            {s.icon({
              color: "primary",
              sx: { mb: 2, fontSize: "50px" },
            })}
            <Typography
              variant="subtitle1"
              textAlign="left"
              sx={{ py: 1, color: (theme) => theme.palette.grey[700] }}
            >
              {s.name}
            </Typography>
            <Typography
              variant="subtitle2"
              textAlign="left"
              sx={{ color: (theme) => theme.palette.grey[700] }}
              fontFamily="Lato-Regular"
              lineHeight={2}
            >
              {s.text}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
export default Benefits;
